/**
 * Addon Catalog (frontend)
 * ========================
 * Espelho do backend/constants/addon_catalog.py para exibição na UI.
 * O backend é a fonte de verdade dos price_ids; o frontend só envia o id
 * estável (ex: "ebook_instagram_vende") na rota /create-checkout-session.
 *
 * A ORDEM deste array é a ordem de renderização na tela /services.
 */

import { BookOpen, Headphones } from 'lucide-react';

export const ADDON_CATALOG = [
  {
    id: 'ebook_instagram_vende',
    type: 'ebook',
    name: 'E-book: Instagram que Vende',
    tagline: 'Estratégias para Atrair Clientes Todos os Dias',
    description: 'Um e-book prático com foco em transformar o Instagram em canal de vendas.',
    amountCents: 599,
    priceFormatted: 'R$ 5,99',
    icon: BookOpen,
    accent: 'amber',
    showInRegistration: true,
  },
  {
    id: 'ebook_atendimento_encantar',
    type: 'ebook',
    name: 'E-book: O Atendimento que Muda Tudo',
    tagline: 'Método definitivo para encantar e vender',
    description: 'Transforme cada interação em oportunidade de fidelização. Respostas rápidas, social selling e uso de IA para escalar o atendimento ao cliente.',
    amountCents: 599,
    priceFormatted: 'R$ 5,99',
    icon: BookOpen,
    accent: 'amber',
    showInRegistration: false,
  },
  {
    id: 'ebook_codigo_conexao',
    type: 'ebook',
    name: 'E-book: O Código da Conexão',
    tagline: 'Segredos do marketing digital para pequenos negócios',
    description: 'Manual prático: conexão com audiência, posicionamento, conteúdo e canais que realmente convertem.',
    amountCents: 599,
    priceFormatted: 'R$ 5,99',
    icon: BookOpen,
    accent: 'amber',
    showInRegistration: false,
  },
  {
    id: 'consultoria_60min',
    type: 'consultoria',
    name: 'Consultoria 60min',
    tagline: 'Acompanhamento estratégico personalizado',
    description: 'Durante os 60 minutos, nossa equipe analisa o seu posicionamento atual e traz direcionamentos práticos para melhorar a comunicação, o conteúdo e a estratégia digital da sua empresa.',
    amountCents: 15000,
    priceFormatted: 'R$ 150,00',
    icon: Headphones,
    accent: 'blue',
    showInRegistration: true,
  },
];

export const ADDON_BY_ID = ADDON_CATALOG.reduce((acc, a) => {
  acc[a.id] = a;
  return acc;
}, {});

export function getAddon(id) {
  return ADDON_BY_ID[id];
}

export function sumAddonsCents(ids = []) {
  return ids.reduce((sum, id) => sum + (ADDON_BY_ID[id]?.amountCents || 0), 0);
}

export function formatBRL(cents) {
  const value = (cents || 0) / 100;
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
